import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { MultaService } from '../services/multa.service';
import { ProfissionalService } from '../services/profissional.service';
import { TipoMultaService } from '../services/tipo-multa.service';
import { VeiculoService } from '../services/veiculo.service';
import { UnidadeService } from '../services/unidade.service';
import { ClienteService } from '../services/cliente.service';

import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-multas-edit',
	templateUrl: './multas-edit.component.html',
	styleUrls: ['./multas-edit.component.css'],
	animations: [loadingFade]
})
export class MultasEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public multa_id = null;
	public unidades = [];
	public agencias = [];
	public veiculos = [];

	public formMulta: FormGroup;
	
	public profissional_array = [];
	public veiculo_array: NgOption[] = [];
	public tipo_multa_array = [];
	public qtde_char_descricao = 0;


	// datepickers
	public data_infracao_dp;
	public data_notif_dp;
	public data_transf_dp;
	public data_venc_dp;

	//filtro
	public usuario$usuario_nome = null;
	public profissional$profissional_nome = null;
	public tipo_multa_id = null;
	public multa_data_infracao___data_i = null;
	public multa_data_infracao___data_f = null;	

	constructor(private authSvc: AuthService,
				private route: ActivatedRoute,
				private fb: FormBuilder,
				private multaSvc: MultaService,
				private profSvc: ProfissionalService,
				private router: Router,
				private tipoMultaSvc: TipoMultaService,
				private unidadeSvc: UnidadeService,
				private clienteSvc: ClienteService,
				private veiculoSvc: VeiculoService) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {

				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "usuario$usuario_nome": { 
						 this.usuario$usuario_nome = loSplitValor[1];
						 break; 
					  } 
					  case "profissional$profissional_nome": { 
						this.profissional$profissional_nome = loSplitValor[1];
						 break; 
					  } 
					  case "tipo_multa_id": { 
						this.tipo_multa_id = loSplitValor[1];
						 break; 
					  } 
					  case "multa_data_infracao___data_i": { 
						this.multa_data_infracao___data_i = loSplitValor[1];
						 break; 
					  }      
					  case "multa_data_infracao___data_f": { 
						this.multa_data_infracao___data_f = loSplitValor[1];
						 break; 
					  }      
                                                      
				   }
		
				  }
		
		
				}

				this.multa_id = params.id;
				// pega dados a partir do id
				this.multaSvc.getMulta(params.id).then((data: any) => {

					console.log("[data getMulta] =" , data);

					let data_infr = null, data_notif = null, data_transf = null, data_venc = null;

					if (moment(data.multa_data_infracao).isValid()) {
						let moment_date = moment(data.multa_data_infracao, 'YYYY-MM-DD');
						data_infr = moment_date.format('DD/MM/YYYY');
						this.data_infracao_dp.setDate(moment_date.toDate());
					}
					if (moment(data.multa_data_notificacao).isValid()) {
						let moment_date = moment(data.multa_data_notificacao, 'YYYY-MM-DD');
						data_notif = moment_date.format('DD/MM/YYYY');
						this.data_notif_dp.setDate(moment_date.toDate());
					}
					if (moment(data.multa_data_transferencia).isValid()) {
						let moment_date = moment(data.multa_data_transferencia, 'YYYY-MM-DD');
						data_transf = moment_date.format('DD/MM/YYYY');
						this.data_transf_dp.setDate(moment_date.toDate());
					}
					if (moment(data.multa_data_vencimento).isValid()) {
						let moment_date = moment(data.multa_data_vencimento, 'YYYY-MM-DD');
						data_venc = moment_date.format('DD/MM/YYYY');
						this.data_venc_dp.setDate(moment_date.toDate());
					}

					this.pegaUnidadesByAgencia(data.cliente_id);

					this.preencheForm({
						multa_id: data.multa_id,
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						veiculo_id: data.veiculo_id,
						profissional_id: data.profissional_id,
						tipo_multa_id: data.tipo_multa_id,
						multa_data_infracao: data_infr,
						multa_data_notificacao: data_notif,
						multa_data_transferencia: data_transf,
						multa_data_vencimento: data_venc,
						multa_descricao: data.multa_descricao
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formMulta = this.fb.group({
			multa_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			veiculo_id: [null, Validators.required],
			profissional_id: null,
			tipo_multa_id: [null, Validators.required],
			multa_data_infracao: [null, Validators.required],
			multa_data_notificacao: [null, Validators.required],
			multa_data_transferencia: null,
			multa_data_vencimento: null,
			multa_descricao: '',
			cliente_id: [null, Validators.required],
			unidade_id: [null, Validators.required]
		});

		this.pegaVeiculos();
		this.pegaProfissionais();
		this.pegaTipoMultas();
		this.pegaAgencias();

		let campos_data = [
			{ nome: 'multa_data_infracao', dp: 'data_infracao_dp' },
			{ nome: 'multa_data_notificacao', dp: 'data_notif_dp' },
			{ nome: 'multa_data_transferencia', dp: 'data_transf_dp' },
			{ nome: 'multa_data_vencimento', dp: 'data_venc_dp'}
		];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			this[campo.dp] = Datepicker('#' + campo.nome, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formMulta.controls[campo.nome].setValue(formatted);
				}
			});
		}
	}

	pegaAgencias(){
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.agencias = data;
		}).catch((err) => {
		  console.log(err);
		});
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					unidade_id: veiculo.unidade_id,
					cliente_id: veiculo.cliente_id
				});
			}
			this.veiculo_array = dados;
		}).catch((err) => {
			console.log(err)
		});
	}

	pegaUnidadesByAgencia(agencia_id){
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
		  this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	pegaProfissionais() {
		this.profSvc.getProfissionais('profissional_nome').then((data: any[]) => {
			this.profissional_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaTipoMultas() {
		this.tipoMultaSvc.getTiposMulta('tipo_multa_nome').then((data: any[]) => {
			this.tipo_multa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaNaturezaTipoMulta() {
		for (let tipo of this.tipo_multa_array) {
			if (tipo.tipo_multa_id == this.formMulta.value.tipo_multa_id)
				return tipo.tipo_multa_natureza;
		}
		return '';
	}

	pegaPontuacaoTipoMulta() {
		for (let tipo of this.tipo_multa_array) {
			if (tipo.tipo_multa_id == this.formMulta.value.tipo_multa_id)
				return tipo.tipo_multa_pontuacao;
		}
		return '';
	}

	preencheForm(dados) {
		this.formMulta.setValue(dados);
	}

	onChangeVeiculo(e) {
		this.formMulta.controls['unidade_id'].setValue(e.unidade_id);
		this.formMulta.controls['cliente_id'].setValue(e.cliente_id);
	}

	enviaMulta() {
		if (this.formMulta.valid) {
			this.submitting = true;

			let toSend = this.formMulta.value;

			if (this.multa_id === null) { // criar
				this.multaSvc.criaMulta(toSend).then((data) => {
					console.log('resp', data);
					this.tipoMultaSvc.getTipoMulta(toSend.tipo_multa_id).then((data: any) => {
						let pontuacao = data.tipo_multa_pontuacao;
						this.profSvc.getProfissional(toSend.profissional_id).then((data: any) => {
							let dados = {
								'profissional_id' : data.profissional_id,
								'profissional_pontuacao_cnh': (parseInt(data.profissional_pontuacao_cnh) + parseInt(pontuacao))
							};
							this.profSvc.editaProfissional(dados).then((data: any) => {
								console.log('resp', data);
							}).catch((err) => {
								console.log(err);
							});
						}).catch((err) =>{
							console.log(err);
						});
					}).catch((err) => {
						console.log(err);
					});
					
					//***********************************************
					Swal.fire({
						type:'success',
						title:'Multa cadastrada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/multas']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.multaSvc.editaMulta(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Multa alterada com sucesso!',
						onClose:() => {
							this.router.navigate(['home/multas']);
						}
					});
				}).catch(err => {
					console.log(err);
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formMulta.controls){
				let campo = this.formMulta.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formMulta.get(nome);
		return input.touched && input.invalid;
	}

	onKeyUpDescricao(e) {
		this.qtde_char_descricao = this.formMulta.value.multa_descricao.length;
	}

	onClickVoltar(){

		let params = 'usuario$usuario_nome=' + this.usuario$usuario_nome;
		params += "&profissional$profissional_nome=" + this.profissional$profissional_nome;
		params += "&tipo_multa_id=" + this.tipo_multa_id;
		params += "&multa_data_infracao___data_i=" + this.multa_data_infracao___data_i;
		params += "&multa_data_infracao___data_f=" + this.multa_data_infracao___data_f;
	
		this.router.navigate(['/home/multasfiltro/' + params]);
	
	  }	  

	  verificaCliente() {
		if (this.formMulta.get('cliente_id').value)
			this.formMulta.get('unidade_id').enable();
		else
			this.formMulta.get('unidade_id').disable();
	}

	onChangeAgencia(e){
		this.formMulta.controls.unidade_id.setValue(null);
		this.formMulta.controls.veiculo_id.setValue(null);
		this.verificaCliente();
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
			this.unidades = data;
		}).catch((err) => {
			console.log(err);
		});
	}


	onChangeVeiculoUnidade(e){

		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"ambulancia").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}
	
			this.veiculos = dados;
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
	}

}
